import { render, staticRenderFns } from "./StrenghtMeter.vue?vue&type=template&id=2548b9ef&"
import script from "./StrenghtMeter.vue?vue&type=script&lang=js&"
export * from "./StrenghtMeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports